import { Injectable } from '@angular/core';
import moment from 'moment';
import { StorageHandler } from './storage-handler';

@Injectable()
export class CookieHandler {
  constructor(private storageHandler: StorageHandler) {}

  public createLSCookie(name: string, value: string, hours: number) {
    // const date = new Date();
    // name = this.href + ':' + name;
    if (!hours) {
      hours = 24;
    }
    const expiresAt = moment().add(hours, 'hours');
    // date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    this.storageHandler.setLocalStorage(name, value);
    this.storageHandler.setLocalStorage(name + 'expires_at', JSON.stringify(expiresAt.valueOf()));
    // expires = "; expires=" + date.toUTCString();
    // document.cookie = name + "=" + value + expires + "; path=/";
  }

  public readLSCookie(name: string) {
    // name = this.href + ':' + name;
    const ca = this.storageHandler.getLocalStorage(name);
    if (this.isLoggedIn(name)) {
      if (ca) {
        return ca;
      }
    } else {
      this.deleteLSCookie(name);
    }
    return null;
  }

  public deleteLSCookie(name: string) {
    // name = this.href + ':' + name;
    localStorage.removeItem(name);
    this.storageHandler.removeLocalStorage(name + 'expires_at');
  }

  public isLoggedIn(name) {
    // name = this.href + ':' + name;
    return moment().isBefore(this.getExpiration(name));
  }

  getExpiration(name) {
    // name = this.href + ':' + name;
    const expiration = this.storageHandler.getLocalStorage(name + 'expires_at');
    const expiresAt = JSON.parse(expiration);
    return moment(expiresAt);
  }
}
